export const LICENSE_STATUS = {
  OK: "ok",
  WARNING: "warning",
  ERROR: "error"
};

export class License {
  public id: number;
  public status: string | null;
  public expirationDate: Date | null;
  public qualityIndexEnable: boolean;
  public content: string | null;
  public technology: string | null;

  public constructor() {
    this.id = 0;
    this.status = null;
    this.expirationDate = null;
    this.qualityIndexEnable = false;
    this.content = null;
    this.technology = null;
  }

  public isOk(): boolean {
    return this.status ? this.status === LICENSE_STATUS.OK : true;
  }
  public isWarning(): boolean {
    return this.status === LICENSE_STATUS.WARNING;
  }
  public isError(): boolean {
    return this.status === LICENSE_STATUS.ERROR;
  }
  public isNotOk(): boolean {
    return this.status !== LICENSE_STATUS.OK;
  }
}
